"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    validGoogleSymbols: ()=>validGoogleSymbols
});
const validGoogleSymbols = [
    'accessible',
    'account_tree',
    'auto_transmission',
    'add',
    'airline_seat_legroom_extra',
    'airline_seat_legroom_normal',
    'airline_seat_legroom_reduced',
    'airline_seat_recline_normal',
    'airport_shuttle',
    'api',
    'app_registration',
    'apps',
    'apps_outage',
    'architecture',
    'arrow_back',
    'arrow_downward',
    'arrow_drop_down',
    'arrow_forward',
    'arrow_upward',
    'article',
    'attach_money',
    'assessment',
    'bed',
    'beach_access',
    'bookmark',
    'bookmark_add',
    'box_edit',
    'bug_report',
    'business_center',
    'build',
    'calendar_clock',
    'calendar_month',
    'call',
    'cancel',
    'carry_on_bag',
    'casino',
    'chat',
    'check',
    'check_box',
    'check_box_outline_blank',
    'check_circle',
    'check_indeterminate_small',
    'checked_bag',
    'chevron_left',
    'chevron_right',
    'close',
    'content_copy',
    'currency_exchange',
    'cycle',
    'dashboard',
    'database',
    'database_search',
    'database_upload',
    'date_range',
    'delete',
    'delete_sweep',
    'deployed_code',
    'deployed_code_account',
    'deployed_code_alert',
    'deployed_code_history',
    'deployed_code_update',
    "description",
    'developer_board',
    'directions_boat',
    'directions_car',
    'eco',
    'edit',
    'editor_choice',
    'email',
    'error',
    'expand_more',
    'explore',
    'family_restroom',
    'favorite',
    'first_page',
    'fitness_center',
    'flash_on',
    'flight_takeoff',
    'format_quote',
    'fork_spoon',
    'group',
    'groups',
    'heart_plus',
    'help',
    'history',
    'home',
    'hot_tub',
    'hub',
    'id_card',
    'image',
    'info',
    'integration_instructions',
    'key',
    'keyboard_arrow_down',
    'last_page',
    'layers',
    'link',
    'local_bar',
    'local_cafe',
    'local_dining',
    'local_taxi',
    'location_city',
    'location_on',
    'local_parking',
    'lock',
    'login',
    'logout',
    'luggage',
    'mail',
    'manage_accounts',
    'menu',
    'menu_open',
    'monitoring',
    'motion_photos_auto',
    'my_location',
    'network_node',
    'north',
    'open_in_new',
    'paid',
    'pause',
    'pets',
    'play_arrow',
    'photo_library',
    'person',
    'policy',
    'pool',
    'priority_high',
    'radio_button_checked',
    'radio_button_unchecked',
    'refresh',
    'remove',
    'restaurant',
    'route',
    'schedule',
    'search',
    'security',
    'sell',
    'settings',
    'smoke_free',
    'south',
    'spa',
    'star',
    'swap_horiz',
    'sync',
    'task_alt',
    'time_to_leave',
    'track_changes',
    'tune',
    'unfold_more',
    'verified',
    'verified_user',
    'vital_signs',
    'warning',
    'work',
    'webhook',
    'wifi',
    'widgets'
];
exports.validGoogleSymbols = __webpack_exports__.validGoogleSymbols;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "validGoogleSymbols"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
